import { Button } from "@/components/ui/button";

/**
 * Footer for a server-paged table: where you are, how many rows the filters
 * match, and Previous / Next. One list showing one API page as if it were
 * everything is how the Employees, Attendance, Requests and Roster screens all
 * hid row 201 onwards (2026-10-29).
 */
export function ListPager({
  page,
  pageSize,
  total,
  loading,
  onPageChange,
  noun = "records",
}: {
  page: number;
  pageSize: number;
  total: number;
  loading?: boolean;
  onPageChange: (page: number) => void;
  /** What a row is, for the count: "1–50 of 1,824 records". */
  noun?: string;
}) {
  if (total === 0) return null;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between border-t px-4 py-2.5 text-xs text-muted-foreground">
      <span>
        {totalPages > 1 && <span className="mr-2">Page {page} of {totalPages}</span>}
        <span>
          {totalPages > 1 ? "· " : ""}
          {first.toLocaleString()}–{last.toLocaleString()} of {total.toLocaleString()} {noun}
        </span>
      </span>
      {totalPages > 1 && (
        <div className="flex gap-2">
          <Button size="sm" variant="outline" disabled={page <= 1 || loading} onClick={() => onPageChange(page - 1)}>
            Previous
          </Button>
          <Button size="sm" variant="outline" disabled={page >= totalPages || loading} onClick={() => onPageChange(page + 1)}>
            Next
          </Button>
        </div>
      )}
    </div>
  );
}
